<template>
    <div class="wrap">
        <!-- 标题 -->
        <div
        v-if="reloadState === 0"
        class="wrapper">
          <p class="text">信息加载中...</p>
        </div>
        <div
        v-if="reloadState === -1"
        class="wrapper"  @click="clickReload">
        <img src="@/assets/NS-004.png" alt="" class="emptyImage">
          <p class="text">暂无数据</p>
        </div>
    </div>
</template>

<script>

import NativeMsg from '@/base/NativeMsg';

export default {
  name: 'FundModuleerror',
  components: {
  },
  props: {
    title: {
      type: String,
      default: 'height: 200px',
    },
    loadStyle: {
      type: String,
      default: '',
    },
    desc: {
      type: String,
      default: '',
    },
    rightBtnDesc: {
      type: String,
      default: '',
    },
    rightBtnEvent: {
      type: Function,
      default: () => {
      },
    },
    moreTitle: {
      type: String,
      default: '',
    },
    emptyTitle: {
      type: String,
      default: '',
    },
    fetchCache: {
      type: Function,
      default: () => null,
    },
    fetchRequest: {
      type: Function,
      default: () => null,
    },
    checkData: {
      type: Function,
      default: () => false,
    },
    nowrightArrow: {
      type: Boolean,
    },
    showMore: {
      type: Function,
      default: () => true,
    },
    isMainQueryError: {
      type: Function,
      default: () => false,
    },
    moreEvent: {
      type: Function,
      default: () => {
      },
    },
    slotNextTick: {
      type: Function,
      default: () => {
      },
    },
  },
  data() {
    return {
      pageData: [],
      reloadState: 0,
      mainStateErr: false,
    };
  },
  computed: {},
  created() {
  },
  mounted() {
    // this.start();

    this.reloadState = -1;
  },
  methods: {
    start() {
      this.reloadState = -1;
    },
    cache() {
    },
    showMainError() {
      if (this.reloadState === 0) {
        this.reloadState = 1;
        this.mainStateErr = true;
      }
    },
    showLogic() {
      this.reloadState = 0;
    },
    clickReload() {
      NativeMsg.post(JSON.stringify({ key: 'mainEmpyreflash', value: { v: 'start' } }));
      this.showLogic();
    },
    clickMore() {
      this.moreEvent();
    },
  },
};
</script>

<style scoped lang="less">
.wrap{
  display: flex;
  border-radius: 12px;
  height: 100%;
  width: 100%;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.cell-wrap {
}
.wrapper {
    height: 100%;
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
  align-items: center;
}
.emptyImage{
  height: 400px;
  margin-bottom: 20px;
}
.text {
    height: 40px;
    width: 100%;
    font-family: PingFangSC-Regular;
    font-size: 30px;
    color: #999999;
    text-align: center;
}
</style>
